export default class Colours {
	static getDistinctColour(index, ignoreStatusColours = false) {
		let colourPool = ["#e6194B", "#f58231", "#ffe119", "#bfef45", "#3cb44b", "#42d4f4", "#4363d8", "#911eb4", "#f032e6", "#a9a9a9"];
		if (ignoreStatusColours) {
			colourPool = colourPool.slice(3, colourPool.length);
		}
		if (!index || index < 0) {
			return "#000000";
		}
		return colourPool[index % colourPool.length];
	}
}
